export default __webpack_public_path__ + "static/dress-87fc3bf76b195863bf5c22f1a27d0f1a.png";